import { color } from '../../../atoms/colors';

const socialData = slug => [
  {
    name: 'x',
    url: `http://www.twitter.com/intent/tweet?url=https://www.upkeep.com${slug}&via=UpKeep`,
    icon: 'twitter-x',
    ariaLabel: 'Share on X',
    iconColor: color.darkBlue[1000],
  },
  {
    name: 'linkedin',
    url: `https://www.linkedin.com/sharing/share-offsite/?url=https://www.upkeep.com${slug}`,
    icon: 'linkedin',
    ariaLabel: 'Share on LinkedIn',
    iconColor: color.darkBlue[1000],
  },
  {
    name: 'facebook',
    url: `http://www.facebook.com/sharer/sharer.php?u=https://www.upkeep.com${slug}`,
    icon: 'facebook',
    ariaLabel: 'Share on Facebook',
    iconColor: color.darkBlue[1000],
  },
];

export default socialData;
